export const COMMERCIAL = 'COMMERCIAL'; // Менеджер ОВП
export const ENGINEERING_NETWORKS = 'ENGINEERING_NETWORKS'; // Инженер ОВП
export const FURNISHING_SUPERVISOR = 'FURNISHING_SUPERVISOR'; // Куратор мебели
export const HEAD_EN = 'HEAD_EN'; // Руководитель ИС
export const HEAD_OVP = 'HEAD_OVP'; // Руководитель ОВП
export const OBSERVER = 'OBSERVER'; // Наблюдатель
export const PARTNER = 'PARTNER'; // Партнер
export const PLANNER = 'PLANNER'; // Планировщик
export const PRIME_CONTRACTOR = 'PRIME_CONTRACTOR'; // Генеральный подрядчик
export const HOUSING_CONTRACTOR = 'HOUSING_CONTRACTOR'; // Генеральный подрядчик ИЖС
export const USK_PRE_ACCEPTANCE = 'USK_PRE_ACCEPTANCE'; // Предприемка УСК
export const SUPERVISOR = 'SUPERVISOR'; // Руководитель
export const UNSET = 'UNSET'; // Роль не задана
